<ion-header
  class="ion-no-border"
  [ngClass]="
    platform !== platformRef.desktop
      ? platform === platformRef.tablet
        ? 'ion-header-modal-tablet'
        : 'ion-header-modal-mobile'
      : 'ion-header-modal-desktop'
  "
>
  <ion-toolbar>
    <ion-buttons *ngIf="platform === platformRef.desktop" slot="end">
      <ion-button
        id="close-modal-btn"
        data-cy="close-confirm-delete-modal-button"
        (click)="dismiss()"
      >
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content
  data-cy="modal-prompt-area-text-delete"
  class="simple-action-modal_content"
  tabletTouchMove
  [ngClass]="
    platform !== platformRef.desktop
      ? platform === platformRef.tablet
        ? 'ion-content-modal-tablet'
        : 'ion-content-modal-mobile'
      : 'ion-content-modal-desktop'
  "
>
  <ion-grid>
    <ion-row
      *ngIf="platform !== platformRef.desktop"
      class="icon"
      [class.tablet]="platform === platformRef.tablet"
      [class.mobile]="platform === platformRef.mobile"
    >
      <ion-col>
        <img src="assets/icon/alert-red.svg" class="warning-icon" />
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col class="icon" *ngIf="platform === platformRef.desktop" size="3">
        <img src="assets/icon/alert-red.svg" class="warning-icon" />
      </ion-col>
      <ion-col [size]="platform === platformRef.desktop ? 9 : 12">
        <ion-row>
          <ion-col>
            <p
              class="title"
              [class.tablet]="platform === platformRef.tablet"
              [class.mobile]="platform === platformRef.mobile"
            >
              {{ 'i18n.menuProfitPro.deleteModal.title' | translate }}
              <span class="green" *ngIf="data.selectedIds.length === 1"
                >{{ data.selectedIds.length
                }}{{
                  'i18n.menuProfitPro.deleteModal.recipe' | translate
                }}</span
              >
              <span class="green" *ngIf="data.selectedIds.length > 1"
                >{{ data.selectedIds.length
                }}{{
                  'i18n.menuProfitPro.deleteModal.recipes' | translate
                }}</span
              >
            </p>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <p
              *ngIf="
                data.dependentRecipes.length > 0 ||
                data.dependentMenus.length > 0 ||
                data.dependentMenuItems.length > 0
              "
              class="sub-title"
              [class.tablet]="platform === platformRef.tablet"
              [class.mobile]="platform === platformRef.mobile"
            >
              {{ 'i18n.menuProfitPro.deleteModal.affects' | translate }}
            </p>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <div
              class="scrolling-container"
              [class.tablet]="platform === platformRef.tablet"
              [class.mobile]="platform === platformRef.mobile"
              [class.collapse]="
                data.dependentRecipes.length === 0 &&
                data.dependentMenus.length === 0 &&
                data.dependentMenuItems.length === 0
              "
            >
              <div
                *ngIf="
                  data.dependentRecipes.length === 0 &&
                  data.dependentMenus.length === 0 &&
                  data.dependentMenuItems.length === 0
                "
              >
                <p class="no-affect">
                  {{ 'i18n.menuProfitPro.deleteModal.noAffects' | translate }}
                </p>
              </div>
              <div *ngIf="data.dependentRecipes.length > 0">
                <p class="bold">
                  {{ 'i18n.menuProfitPro.deleteModal.header1' | translate }}
                </p>
                <p class="items">{{ data.dependentRecipes }}</p>
              </div>
              <div *ngIf="data.dependentMenuItems.length > 0">
                <p class="bold">
                  {{ 'i18n.menuProfitPro.deleteModal.header2' | translate }}
                </p>
                <p class="items">{{ data.dependentMenuItems }}</p>
              </div>
              <div *ngIf="data.dependentMenus.length > 0">
                <p class="bold">
                  {{ 'i18n.menuProfitPro.deleteModal.header3' | translate }}
                </p>
                <p class="items">{{ data.dependentMenus }}</p>
              </div>
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <p
              class="sub-title"
              [class.tablet]="platform === platformRef.tablet"
              [class.mobile]="platform === platformRef.mobile"
            >
              {{ 'i18n.menuProfitPro.deleteModal.ifAny' | translate }}
            </p>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        id="no-modal-btn"
        data-cy="no-confirm-info-delete-modal-button"
        [ngClass]="
          platform !== platformRef.mobile
            ? 'usf-outline-green-dsktp-tblt-modal-button'
            : 'usf-outline-green-mobile-modal-button'
        "
        (click)="submit()"
      >
        {{ 'i18n.common.continue' | translate }}
      </ion-button>
      <ion-button
        id="yes-modal-btn"
        data-cy="submit-info-delete-modal-button"
        [ngClass]="
          platform !== platformRef.mobile
            ? 'usf-fill-green-dsktp-tblt-modal-button'
            : 'usf-fill-green-mobile-modal-button'
        "
        (click)="dismiss()"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
